<template>
  <v-container fluid class="admin-white-card">
    <v-row class="flex-grow-0">
      <v-col class="text-right">
        <v-btn color="primary"
               class="mr-4"
               @click="exportWhiteCardQrCodes">
          {{ $t('admin_acc_white_card.export') }}
        </v-btn>
        <v-btn color="primary"
               @click="addWhiteCard">
          {{ $t('admin_acc_white_card.add') }}
        </v-btn>
      </v-col>
    </v-row>
    <WhiteCardList full-height
                   :refresh-trigger.sync="whiteCardRefreshTrigger"
                   @record="onShowCheckInRecord"></WhiteCardList>

    <WhiteCardActiveRecordModal :shown="checkInRecordModalShown"
                                :record-id="showingCheckInRecordId"
                                @cancel="onCheckInRecordModalFinish"></WhiteCardActiveRecordModal>
  </v-container>
</template>


<script>
import {ref} from "@vue/composition-api";
import WhiteCardList from "@/components/acc_booking/white_card/WhiteCardList";
import WhiteCardActiveRecordModal from "@/components/acc_booking/white_card/WhiteCardActiveRecordModal";

export default {
  name: 'AccWhiteCard',
  components: {WhiteCardActiveRecordModal, WhiteCardList},
  setup(props, {root}) {

    const addWhiteCard = function () {
      if (confirm(root.$t('admin_acc_white_card.add_confirm_msg'))) {
        root.$callAPI('aafb/admin/white_card/create/', {}, (response) => {
          // editingWhiteCardId.value = response.body.white_card.id;
          // editWhiteCardModalShown.value = true;
          whiteCardRefreshTrigger.value = true;
        })
      }
    };

    const selectedWhiteCardIds = ref([]);
    const whiteCardRefreshTrigger = ref(false);

    const showingCheckInRecordId = ref(null);
    const checkInRecordModalShown = ref(false);
    const onShowCheckInRecord = function (recordId) {
      showingCheckInRecordId.value = recordId;
      checkInRecordModalShown.value = true;
    }
    const onCheckInRecordModalFinish = function () {
      checkInRecordModalShown.value = false;
      whiteCardRefreshTrigger.value = true;
    }

    const exportWhiteCardQrCodes = function () {
      root.$downloadFile('aafb/admin/white_card/export/', {}, 'white_cards.zip', 'application/zip')
    };

    return {
      addWhiteCard,

      selectedWhiteCardIds,
      whiteCardRefreshTrigger,
      showingCheckInRecordId,
      checkInRecordModalShown,
      onShowCheckInRecord,
      onCheckInRecordModalFinish,
      exportWhiteCardQrCodes,
    }
  },
}
</script>

<style lang="less">
.admin-white-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
